import React, { useState } from 'react';
import { Modal, Spinner } from 'react-bootstrap';
import { Info, Save, X } from 'lucide-react';
import '../Personell/employee-form.css';

const CreatePayrollModal = ({ show, handleClose, handleSave, isCreating = false }) => {
  const [selectedDate, setSelectedDate] = useState(new Date().toISOString().split('T')[0]);
  const [error, setError] = useState('');

  const handleDateChange = (e) => {
    setSelectedDate(e.target.value);
    setError(''); // Clear error when user changes date
  };

  const handleSaveClick = async () => {
    if (!selectedDate) {
      setError('Vänligen välj ett utbetalningsdatum');
      return;
    }

    const selectedDateObj = new Date(selectedDate);
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    if (selectedDateObj < today) {
      setError('Utbetalningsdatum kan inte vara i det förflutna');
      return;
    }

    // Extract year and month from the payout date
    const [year, month] = selectedDate.split('-').map(num => parseInt(num, 10));

    try {
      await handleSave({
        year: year,
        month: month,
        payoutDate: selectedDate
      });
      handleClose();
      setSelectedDate(new Date().toISOString().split('T')[0]); // Reset form
      setError('');
    } catch (err) {
      setError('Ett fel uppstod när lönekörningen skulle skapas');
    }
  };

  const handleModalClose = () => {
    if (!isCreating) {
      setSelectedDate(new Date().toISOString().split('T')[0]);
      setError('');
      handleClose();
    }
  };

  const getPayoutDateInfo = () => {
    if (!selectedDate) return '';

    const date = new Date(selectedDate);
    const dayOfWeek = date.toLocaleDateString('sv-SE', { weekday: 'long' });
    const formatted = date.toLocaleDateString('sv-SE', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });

    return `${dayOfWeek}, ${formatted}`;
  };

  return (
    <>

      <Modal
        className="emp-modal"
        show={show}
        onHide={handleModalClose}
        backdrop={isCreating ? 'static' : true}
        keyboard={!isCreating}
      >
        <Modal.Header closeButton={!isCreating}>
          <Modal.Title>
            Skapa ny lönekörning
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="form-info">
            <Info size={20} className="info-icon" />
            <div className="info-text">
              <strong>Skapa en ny löneperiod</strong><br />
              Välj det datum då lönerna kommer att betalas ut till de anställda.
              Detta datum används för att planera utbetalningar och kan ändras senare om det behövs.
            </div>
          </div>

          {error && (
            <div className="validation-summary">
              <X size={16} />
              {error}
            </div>
          )}

          <div className="row">
            <div className="col-md-6">
              <div className="input-group">
                <label className="input-label">
                  Utbetalningsdatum *
                </label>
                <input
                  type="date"
                  className="modern-input"
                  value={selectedDate}
                  onChange={handleDateChange}
                  min={new Date().toISOString().split('T')[0]}
                  disabled={isCreating}
                  required
                />
              </div>
            </div>

            <div className="col-md-6">
              {selectedDate && (
                <div className="current-value-card mb-0">
                  <div className="current-value-label">Valt datum</div>
                  <div className="current-value-text">
                    {getPayoutDateInfo()}
                  </div>
                </div>
              )}
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <button
            type="button" className="ll-btn ll-btn--secondary"
            onClick={handleModalClose}
            disabled={isCreating}
          >
            <X size={16} />
            Avbryt
          </button>

          <button
            type="button" className="ll-btn ll-btn--primary"
            onClick={handleSaveClick}
            disabled={isCreating || !selectedDate}
          >
            {isCreating ? (
              <>
                <div className="loading-spinner" />
                Skapar...
              </>
            ) : (
              <>
                <Save size={16} />
                Skapa lönekörning
              </>
            )}
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default CreatePayrollModal;




// import React, { useState } from 'react';
// import { Modal, Button } from 'react-bootstrap';

// const CreatePayrollModal = ({ show, handleClose, handleSave }) => {
//   const [selectedDate, setSelectedDate] = useState(new Date().toISOString().split('T')[0]);

//   const handleDateChange = (e) => {
//     setSelectedDate(e.target.value);
//   };

//   const handleSaveClick = () => {
//     handleSave(selectedDate);
//     handleClose();
//   };

//   return (
//     <Modal className='fade bd-example-modal-lg' size='lg' show={show} onHide={handleClose}>
//       <Modal.Header closeButton>
//         <Modal.Title>Ny lönekörning</Modal.Title>
//       </Modal.Header>
//       <Modal.Body>
//         <div className='col-lg-12'>
//           <div className='row'>
//             <div className="col-lg-4">
//               <div>
//                 Välje det datum då löner kommer att betalas ut.
//               </div>
//             </div>
//             <div className="col-xl-4">
//               <div className="form-group mb-3 invoice">
//                 <label>Utbetalningsdatum</label>
//                 <input
//                   size="16"
//                   type="date"
//                   className="form-control"
//                   value={selectedDate}
//                   onChange={handleDateChange}
//                   min={new Date().toISOString().split('T')[0]}
//                 />
//               </div>
//             </div>
//           </div>
//         </div>
//       </Modal.Body>
//       <Modal.Footer>
//         <Button variant="secondary" onClick={handleClose}>
//           Cancel
//         </Button>
//         <Button variant="primary" onClick={handleSaveClick}>
//           Save
//         </Button>
//       </Modal.Footer>
//     </Modal>
//   );
// };

// export default CreatePayrollModal;